module.exports = __webpack_public_path__ + "static/img/thumb_14.d786331.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/menu/thumb_14.png
// module id = 7MGy
// module chunks = 0